// extracted by mini-css-extract-plugin
export default {"switch":"AlertSwitch_switch__UK9Ke","disabled":"AlertSwitch_disabled__WW7xT","slider":"AlertSwitch_slider__qaPW7","sliderTransparent":"AlertSwitch_sliderTransparent__vpeM-"};